import {
  apiRequest,
  P3KlistPeriod,
} from "../../../../../services/adapters/kepegawaian/P3KService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      P3KlistPeriod,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
